import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';
import { ProjectActions } from '../../../actions/project';
import { currentProjectIdSelector } from '../../../reducers/projects';
// import '../../styles/ProjectUsers.css';

import P6ExportModule from './P6Export';

const DefaultPageSelector = immutableCreatorSelector(
  [currentProjectIdSelector],
  currentProjectId => ({
    currentProjectId,
  }),
);

@connect(DefaultPageSelector)
export default class ProjectExport extends PureComponent {
  static propTypes = {};

  exportModules = {
    JSON: 'json',
    P6: P6ExportModule,
    MSPROJECT: 'msproject'
  };

  constructor() {
    super();
    this.state = {
      submitting: false,
      file: null,
    };
  }

  moduleLookup(module) {
    return module ? this.exportModules[module] : undefined;
  }

  onChange(e) {
    const module = e.target.value;

    if (module) {
      this.setState({
        moduleName: module,
      });
    }
  }

  downloadFile = url => {
    this.setState({
      submitting: false,
      file: url,
    });
    window.location.href = url;
  };

  handleOnClick = () => {
    const { dispatch, currentProjectId } = this.props;
    const { moduleName } = this.state;

    this.setState({ submitting: true });
    dispatch(ProjectActions.downloadExport(currentProjectId, moduleName)).then(res => {
      const s3Url = `//${res.result.Bucket}/${res.result.key}`;
      this.downloadFile(s3Url);
    });
  };

  render() {
    const { submitting, file, moduleName } = this.state;

    const exportModule = this.moduleLookup(moduleName);

    const options = (
      <div>
        <select
          name="module"
          className="form-control c-select"
          onChange={::this.onChange}
        >
          <option value="">Select One...</option>
          {
            Object.keys(this.exportModules).map((k) =>{
              return (<option value={k}>{k}</option>)
            })
          }
       </select>
      </div>
    );

    const buttonTitle = submitting ? (
      <div>
        <i className="fa fa-spinner fa-pulse fa-fw" />
        Processing...
      </div>
    ) : (
      'Download'
    );

    const downloadButton = (
      <button
        onClick={this.handleOnClick}
        disabled={submitting}
        type="button"
        className="btn btn-primary mt-2"
      >
        {buttonTitle}
      </button>
    );

    const downloadText = file ? (
      <div>
        <small>
          If your download did not start, please{' '}
          <a href={file} target="_blank">
            click here.
          </a>
        </small>
      </div>
    ) : null;
    return (
      <div className="inner-tab-container">
        <div className="row tab-content">
          <span style={{ width: '100%' }}>
            <h1>Export</h1>
            <div className="row">
              <div className="col-md-2" />
              <div className="col-md-8">
                <fieldset className="form-group">
                <label>Select Export Module</label>
                 {options}
                </fieldset>
              </div>
              </div>
              <div className="row">
                <div className="col-md-2" />
               <div className="col-md-8">
                {exportModule ? downloadButton : <div/>}
                {downloadText}
              </div>
            </div>
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/Exports/Exports.js